import Image from "next/image";
import { useEffect, useState } from "react";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./Picture.module.css";

type Props = {
  picture?: string;
  alt?: string;
  className?: string;
  displayLetter?: string;
  // A brand logo must show whole (contain); a photo fills its frame (cover, default).
  contain?: boolean;
};

export default function Picture(props: Props) {
  const { picture, alt, className, displayLetter, contain = false } = props;
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, []);

  const showImage = !!picture && picture !== "" && !hasError;

  return (
    <div className={UStyles.classNames(styles.container, className)}>
      {showImage ? (
        <Image
          fill
          src={picture!}
          alt={alt || ""}
          className={styles.image}
          style={{ objectFit: contain ? "contain" : "cover" }}
          onError={() => setHasError(true)}
          unoptimized
        />
      ) : (
        <span>{displayLetter || "?"}</span>
      )}
    </div>
  );
}
